import React, { Component } from 'react';
import API from '../utils/API';
import history from '../utils/routes/history';
import PrimaryButton from '../Buttons/primaryButton';
import { strings } from '../utils/translations';
import { Errors } from '../utils/errors';
import styles from './auth.module.scss';
import ForgotPassword from './forgotPassword';
import VerifyNewDevice from './VerifyNewDevice'
import CloseIcon from '../../img/icons/closeIcon';
import TeslaIcon from '../../img/icons/tesla.svg'
import QRLogin from './QRLogin'
import { notification } from 'antd'
import classnames from 'classnames'
import { ReactComponent as QuestionmarkIcon } from '../../img/icons/questionmark.svg'

export default class Login extends Component
{
    constructor(props)
    {
        super(props);

        this.state =
        {
            email: '',
            password: '',
            
            isPostLoginVerification: false,
            verifyPostLoginEmail: false,
            showForgotPassword: false,
            
            userId: null,
            phoneNumber: null,
            
            showVerifyNewDevice: false,
            showQrLogin: false,
            
            passwordInputType: "password"
        }

        this.validateFields.bind(this)
        this.sendLogin.bind(this)

        this.forgotData = null
        this.showedLogoutAlert = false
    }

	render()
    {
        const forgotPassword =
            <ForgotPassword
                ref='forgotPasswordScreen'
                loginScreen={this}
                navigator={this.props.navigator}
                closeCard={this.closeForgot.bind(this)}
                data={this.forgotData}
            />
        
        const verifyNewDevice = 
            <VerifyNewDevice
                email={this.state.email.trim()}
                close={this.closeVerifyNewDevice.bind(this)}
                onDeviceVerified={this.onDeviceVerified.bind(this)}
            />
            
        const qrLogin =
            <QRLogin
                
            />

        return(
            <>
                {
                    this.state.showForgotPassword ?
                    forgotPassword
                    :
                    (
                        this.state.showVerifyNewDevice ?
                        verifyNewDevice
                        :
                        (
                            this.state.showQrLogin ?
                            qrLogin
                            :
                            this.renderLoginForm()
                        )
                    )
                }
            </>
        );
    }
    renderLoginForm()
    {
        return (
            <>
                <div className={styles.titleContainer}>
                    <h3>{ strings('login') }</h3>
                </div>
                
                <form>
                    <div className={styles.inputContainer}>
                        <input
                            type="email"
                            className={styles.input}
                            placeholder={ strings('email') }
                            ref='emailInput'
                            value={this.state.email}
                            onChange={e => this.setState({ email: e.target.value })}
                        />    
                    </div>
                    <div className={styles.inputContainer}>
                        <input
                            type={this.state.passwordInputType}
                            className={styles.input}
                            placeholder={ strings('password') }
                            ref='passwordInput'
                            value={this.state.password}
                            onChange={e => this.setState({ password: e.target.value })}
                            onKeyPress={event => { if (event.key === 'Enter') { if (this.validateFields()) this.sendLogin() }}}
                        />
                        <div
                            className={styles.button}
                            onClick={() => {
                                if (this.state.passwordInputType === "password")
                                    this.setState({ passwordInputType: "text" })
                                else
                                    this.setState({ passwordInputType: "password" })
                            }}
                        >
                            {
                                (this.state.passwordInputType === "password") ? strings('show') : strings('hide')
                            }
                        </div>
                    </div>
                    <div className={classnames(styles.bottomLinks, styles.secondaryText)}>
                        <a className={styles.password} onClick={this.showForgot.bind(this)}>
                            <QuestionmarkIcon className={styles.icon} />
                            <div className={styles.text}>
                                { strings('forgotPassword')}
                            </div>
                        </a>
                        <a className={styles.password} onClick={this.showQrLogin.bind(this)}>
                            <img
                                className={styles.icon}
                                src={TeslaIcon}
                            />
                            <div className={styles.text}>
                                { strings('qrLogin')}
                            </div>
                        </a>
                    </div>
                    
                    <PrimaryButton
                        text={ strings('logIn') }
                        onClick={ () => { if (this.validateFields()) this.sendLogin(); } }
                        className={styles.primaryButton}
                    />
                </form>
            </>
        )
    }
 
    validateFields()
    {
        let allOk = true

        if (this.state.email.trim().length == 0)
            allOk = false

        if (this.state.password.length == 0)
            allOk = false
            
        if (!allOk)
        {
            notification.error(
            {
                description: strings('fillInAllTheFields'),
                placement: 'top'
            })
        }

        return allOk
    }
    sendLogin()
    {
        this.refs.emailInput.blur();
        this.refs.passwordInput.blur();

        API.getInstance()
        .login(this.state.email.trim(), this.state.password)
        .then(response =>
        {
            history.push("/garages");
        })
        .catch(error =>
        {            
            let errorMessage = null;

            if (error.response != null)
            {
                switch (error.response.status)
                {
                    case 401:   notification.error(
                                {
                                    description: strings('loginErrorCredentials'),
                                    placement: 'top'
                                })
                                break;
                
                    case 404:   if (error.response.data != null &&
                                    error.response.data.error != null)
                                {
                                    if (error.response.data.error.appError != null &&
                                        error.response.data.error.appError === 101)
                                    {
                                        notification.error(
                                        {
                                            description: strings('loginErrorCredentials'),
                                            placement: 'top'
                                        })
                                    }
                                    else if ((error.response.data.error.emailVerified != null &&
                                        !error.response.data.error.emailVerified) ||
                                        (error.response.data.error.phoneVerified != null &&
                                        !error.response.data.error.phoneVerified))
                                    {
                                        // Verify email and/or phone
                                        this.setState(
                                        {
                                            isPostLoginVerification: true,
                                            verifyPostLoginEmail: (error.response.data.error.emailVerified != null && !error.response.data.error.emailVerified),
                                            verifyPostLoginPhone: (error.response.data.error.phoneVerified != null && !error.response.data.error.phoneVerified),
                                            userId: (error.response.data.error.userId != null) ? error.response.data.error.userId : null,
                                            phoneNumber: (error.response.data.error.phoneNumber != null) ? error.response.data.error.phoneNumber : null
                                            
                                        }, () =>
                                        {
                                            // this.showSignup();
                                        });
                                    }
                                    else if (error.response.data.error.appError === 301 ||
                                             error.response.data.error.appError === 304)
                                    {
                                        // Verify this device
                                        this.showVerifyNewDevice()
                                    }
                                    else
                                    {
                                        notification.error(
                                        {
                                            description: Errors.showAppError(error),
                                            placement: 'top'
                                        })
                                    }
                                }                        
                                break;
    
                    default:  
                        notification.error(
                        {
                            description: Errors.showAppError(error),
                            placement: 'top'
                        })
                    break;
                }
            }
        });
    }
    setLoginEmail(email)
    {
        this.setState({ email })
    }
    
    showForgot()
    {
        this.setState({ showForgotPassword: true }, () =>
        {
            if (this.props.onForgotPasswordShown != null)
                this.props.onForgotPasswordShown(true)
        })
    }
    closeForgot()
    {
        this.setState({ showForgotPassword: false }, () =>
        {
            if (this.props.onForgotPasswordShown != null)
                this.props.onForgotPasswordShown(false)
        })
    }

    showVerifyNewDevice()
    {
        this.setState({ showVerifyNewDevice: true }, () =>
        {
            if (this.props.onVerifyDeviceShown != null)
                this.props.onVerifyDeviceShown(true)
        })
    }
    closeVerifyNewDevice()
    {
        this.setState({ showVerifyNewDevice: false }, () =>
        {
            if (this.props.onVerifyDeviceShown != null)
                this.props.onVerifyDeviceShown(false)
        })
    }
    onDeviceVerified()
    {
        this.closeVerifyNewDevice()
        this.sendLogin()
    }
    
    showQrLogin()
    {
        this.setState({ showQrLogin: true }, () =>
        {
            if (this.props.onQRLoginShown != null)
                this.props.onQRLoginShown(true)
        })
    }
    closeQrLogin()
    {
        this.setState({ showQrLogin: false }, () =>
        {
            if (this.props.onQRLoginShown != null)
                this.props.onQRLoginShown(false)
        })
    }
}
